module.exports = __webpack_public_path__ + "img/bt7_sport_SABASPORTS.f86bc6b0.png";